<div class="trace-loader" role="status" aria-live="polite" [attr.aria-label]="label">
  <!-- Cropped to the band the motion actually occupies: ground sits at y=104, apex at y=28. -->
  <svg class="trace-loader__scene" viewBox="0 12 320 110" aria-hidden="true">
    <defs>
      <!-- Lit side of the track is everything left of the parcel; dim side everything right. -->
      <clipPath id="tlDone"><rect x="0" y="0" width="160" height="150" /></clipPath>
      <clipPath id="tlTodo"><rect x="160" y="0" width="160" height="150" /></clipPath>

      <linearGradient id="tlFadeG" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#000" />
        <stop offset="0.14" stop-color="#fff" />
        <stop offset="0.86" stop-color="#fff" />
        <stop offset="1" stop-color="#000" />
      </linearGradient>
      <mask id="tlFade">
        <rect x="0" y="0" width="320" height="150" fill="url(#tlFadeG)" />
      </mask>

      <!-- currentColor (not fill) so the colour survives being cloned through nested <use>. -->
      <g id="tlPin">
        <rect x="-0.75" y="90" width="1.5" height="13" rx="0.75" fill="currentColor" />
        <circle cx="0" cy="88" r="2.5" fill="currentColor" />
        <circle cx="0" cy="104" r="5" fill="currentColor" />
      </g>

      <!-- Pins every 80 user units, which is exactly one scroll cycle: the loop never seams. -->
      <g id="tlPins">
        <use href="#tlPin" x="0" />
        <use href="#tlPin" x="80" />
        <use href="#tlPin" x="160" />
        <use href="#tlPin" x="240" />
        <use href="#tlPin" x="320" />
        <use href="#tlPin" x="400" />
      </g>
    </defs>

    <g mask="url(#tlFade)">
      <!-- lanes -->
      <line class="lane lane--done" x1="0" y1="104" x2="160" y2="104" />
      <line class="lane lane--todo" x1="160" y1="104" x2="320" y2="104" />

      <!-- checkpoints, dim ahead of the parcel -->
      <g clip-path="url(#tlTodo)">
        <g class="track"><use href="#tlPins" class="pin pin--todo" /></g>
      </g>
      <!-- checkpoints, lit behind it -->
      <g clip-path="url(#tlDone)">
        <g class="track"><use href="#tlPins" class="pin pin--done" /></g>
      </g>
    </g>

    <!-- contact shadow: tightens and darkens as the parcel comes down -->
    <ellipse class="shadow" cx="160" cy="106" rx="17" ry="3.5" />

    <!-- landing stamp -->
    <ellipse class="impact" cx="160" cy="104" rx="15" ry="4" />
    <circle class="puff puff--l" cx="160" cy="101" r="2.6" />
    <circle class="puff puff--r" cx="160" cy="101" r="2.2" />

    <!-- parcel: hop (translateY) → lean (rotate) → squash (scale), each on its own group so the
         transforms compose instead of overwriting each other -->
    <g class="hop">
      <g class="lean">
        <g class="squash">
          <!-- The artwork has transparent padding, so the placement is derived from its alpha
               bounding box (291x255 inside a 350x350 canvas) rather than the canvas: that lands
               the box itself on x 140-180 with its base exactly on the ground line at y=104. -->
          <image href="/parcel-box.webp" x="135.88" y="62.21" width="48.11" height="48.11" />
        </g>
      </g>
    </g>
  </svg>

  <div class="trace-loader__copy">
    <h3 class="trace-loader__title">{{ label }}</h3>
    <p class="trace-loader__caption">{{ caption }}</p>

    @if (epc) {
      <code class="trace-loader__epc">{{ epc }}</code>
    }

    <div class="trace-loader__track" aria-hidden="true"><span class="trace-loader__bar"></span></div>
  </div>
</div>
